export function getPageNum() {
    let queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('page') ? parseInt(queryParams.get('page') ?? '1') : 1;
}
